module.exports = __webpack_public_path__ + "img/mini-024.7467105a.jpg";